export const CONFIG_WHATSAPP_NUMBER = 'https://wa.me/5215513751952';
export const CONFIG_WHATSAPP_FISCAL_NUMBER = '5215561935095';
export const CONFIG_WHATSAPP_NUMBER_DISPATCH = 'https://wa.me/525561778658';
export const CONFIG_WHATSAPP_SUPPORT = 'https://wa.me/5215513751952';
export const CONFIG_WHATSAPP_SALES = 'https://wa.me/525539210421';
export const CONFIG_WHATSAPP_CHURN_NUMBER = 'https://wa.me/525513751952';
